export enum NoteType {
  Rejection = 1,
  Regular = 2
}